<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <label class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md">{{
        $t('wholesale.item')
      }}</label>
      <AddAutoAfterSearchSerial
        v-model="model"
        @calculate="calculate"
        />
        <!-- v-if="!isAccounting" -->
    </div>
    <div class="max-h">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-4"
            >
              {{ $t('wholesale.no') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-64"
            >
              {{ $t('wholesale.product') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16"
            >
              {{ $t('wholesale.quantity') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16"
            >
              {{ $t('wholesale.uom') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16"
            >
              {{ $t('wholesale.unitPrice') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12"
            >
              {{ $t('wholesale.discountType') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12"
            >
              {{ $t('wholesale.discountRate') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-12"
            >
              {{ $t('wholesale.vatRate') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-32"
            >
              {{ $t('wholesale.grandTotal') }}
            </th>
            <th
              class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-20"
            >
              {{ $t('actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(product, index) in model.product_detail"
            :key="index"
            class="ts-border-b ts-border-gray-300"
          >
            <td class="ts-text-center">{{ index + 1 }}</td>
            <td class="ts-px-2 ts-py-1">
              <p class="ts-mb-0 ts-font-extrabold ts-text-blue-600">
                <i class="fab fa-product-hunt"></i>
                {{
                  locale == 'kh'
                    ? product.product_name_kh
                      ? product.product_name_kh
                      : product.product_name_rn
                    : product.product_name_en
                }}
              </p>
              <p class="ts-mb-0">
                <i class="fas fa-barcode"></i> {{ product.barcode }}
              </p>
              <div
                class="validate"
                v-if="errors.has('product_detail.' + index + '.serial_list')"
              >
                {{ errors.first('product_detail.' + index + '.serial_list') }}
              </div>
            </td>
            <td>
              <input
                v-model.number="product.quantity"
                type="number"
                class="form-control ts-text-center"
                :readonly="product.has_serial || isNotAllowToEdit(product)"
                @input="onChangeQuantity(product)"
              />
              <div
                class="ts-text-red-600"
                v-if="errors.has('product_detail.' + index + '.quantity')"
              >
                {{ errors.first('product_detail.' + index + '.quantity') }}
              </div>
            </td>
            <td>
              <a-select
                v-model.number="product.uom_id"
                class="ts-w-full"
                ref="uom"
                :class="{
                  'is-invalid': errors.has(
                    'product_detail.' + index + '.uom_id'
                  )
                }"
                :disabled="isNotAllowToEdit(product)"
                @change="onUomChange(product)"
              >
                <a-select-option
                  v-for="(u, index) in getUom(product.product_id)"
                  :key="index"
                  :value="u.uom_id"
                  >{{ u.uom_name_en }}
                </a-select-option>
              </a-select>
            </td>
            <td>
              <input
                v-model.number="product.unit_price"
                type="number"
                class="form-control ts-text-right"
                @change="onChangeUnitPrice(product)"
                :readonly="isNotAllowToEdit(product)"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('product_detail.' + index + '.unit_price')"
              >
                {{ errors.first('product_detail.' + index + '.unit_price') }}
              </div>
            </td>
            <td>
              <select
                class="form-control"
                ref="discountType"
                v-model="product.discount_type"
                :disabled="isNotAllowToEdit(product)"
                @change="calculate(product)"
              >
                <option value="%">%</option>
                <option :value="default_currency_sign">{{
                  default_currency_sign
                }}</option>
              </select>
            </td>
            <td>
              <input
                v-model.number="product.discount_rate"
                type="text"
                ref="discountRate"
                class="form-control"
                @input="calculate()"
                :readonly="isNotAllowToEdit(product)"
              />
            </td>
            <td>
              <input
                v-model.number="product.vat_rate"
                type="text"
                ref="vatRate"
                class="form-control"
                @input="calculate()"
                :readonly="product.vat_eligible || isNotAllowToEdit(product)"
              />
            </td>
            <td>
              <input
                v-model="product.grand_total"
                type="text"
                class="ts-border ts-w-full ts-border-gray-300 ts-rounded-sm ts-p-2 ts-text-right ts-outline-none ts-font-extrabold"
                readonly
              />
            </td>
            <td class="ts-text-center ts-pl-4 ts-space-x-3">
              <a
                v-if="model.customer_id != null"
                href="#"
                class="ts-text-blue-700"
                @click.prevent="viewPrice(product)"
              >
                <i class="fa fa-dollar-sign ts-mt-2"></i>
              </a>
              <a
                v-if="!isNotAllowToEdit(product)"
                href="#"
                class="ts-text-red-600"
                @click.prevent="removeRow(product)"
              >
                <i class="fa fa-trash"></i>
              </a>
              <a
                href="#"
                v-if="product.has_serial"
                @click.prevent="addSerialProduct(product)"
              >
                <i class="fas fa-list"></i>
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="ts-bg-blue-600" colspan="10"></td>
          </tr>
          <tr class="ts-bg-gray-300">
            <td
              class="ts-px-2 ts-py-1 ts-font-extrabold ts-uppercase"
              colspan="2"
            >
              <span>{{ $t('wholesale.rowNum') }} : </span
              >{{ $formatNumber(numRow) }}
            </td>
            <td
              class="ts-px-2 ts-py-1 ts-font-extrabold ts-text-red-600 ts-uppercase"
            >
              <span>{{ $t('wholesale.qty') }} : </span>
              {{ $formatNumber(countQty) }}
            </td>
            <td class="ts-text-right ts-px-2 ts-py-1" colspan="5">
              <span class="ts-font-extrabold ts-text-red-600 ts-uppercase"
                >{{ $t('wholesale.total') }} :
              </span>
            </td>
            <td class="ts-text-right ts-font-extrabold ts-text-red-600">
              <input
                type="text"
                class="ts-w-full ts-p-2 ts-text-right ts-font-extrabold ts-text-red-700 ts-outline-none"
                :value="
                  totalAmountUSDPrice
                    ? $defaultCurrencyWithCode(
                        totalAmountUSDPrice,
                        default_precision
                      )
                    : 0
                "
                readonly
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3" rowspan="5" class="ts-space-y-1">
              <input
                type="text"
                class="form-control"
                v-model="model.reference_no"
                :disabled="model.quotation_id || model.contract_id"
                :placeholder="$t('wholesale.invoiceNo')"
              />
              <textarea
                v-model.trim="model.remark"
                rows="5"
                class="form-control"
                :placeholder="$t('wholesale.remark')"
              ></textarea>
            </td>
            <td colspan="5" class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('wholesale.discount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="number"
                class="form-control ts-text-right"
                v-model.number="model.discount"
                @input="calculate"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5" class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('wholesale.vatRate') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="number"
                class="form-control ts-text-right"
                v-model.number="model.vat_rate"
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5" class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('wholesale.vatAmount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="text"
                class="ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none"
                :value="
                  model.vat_amount
                    ? $defaultCurrencyWithCode(
                        model.vat_amount,
                        default_precision
                      )
                    : 0
                "
                readonly
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5" class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('wholesale.despositAmount') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="text"
                class="ts-text-right ts-p-2 ts-border ts-border-gray-300 ts-rounded ts-w-full ts-outline-none"
                :value="
                  model.amount_deposit
                    ? $defaultCurrencyWithCode(
                        model.amount_deposit,
                        default_precision
                      )
                    : 0
                "
                readonly
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5" class="ts-text-right">
              <div
                class="ts-bg-blue-600 ts-text-white ts-w-48 ts-float-right ts-p-2 ts-rounded-sm ts-uppercase"
              >
                <b>{{ $t('wholesale.grandTotal') }}</b>
              </div>
            </td>
            <td class="ts-text-right">
              <input
                type="text"
                class="ts-text-right ts-p-2 ts-w-full ts-text-red-700 ts-font-extrabold ts-border ts-border-gray-400 ts-rounded-sm ts-outline-none"
                :value="
                  model.grand_total
                    ? $defaultCurrencyWithCode(
                        model.grand_total,
                        default_precision
                      )
                    : 0
                "
                readonly
              />
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <a-modal
      v-if="show_price"
      v-model="show_price"
      :footer="null"
      :zIndex="1020"
      :maskClosable="false"
      width="650px"
      :title="
        selectedProduct
          ? selectedProduct.barcode +
            '|' +
            selectedProduct.product_name_en +
            ' (' +
            '$ ' +
            selectedProduct.cost +
            '|' +
            '฿ ' +
            selectedProduct.cost * this.thbRate +
            ')'
          : 'N/A'
      "
    >
      <SoldPrice
        v-model="model"
        :selectedProduct="selectedProduct"
        @priceChange="priceChange()"
      />
    </a-modal>
    <a-drawer
      v-if="show_serial_input"
      :title="addSerial.product_name_en"
      :width="400"
      :zIndex="1020"
      :visible="show_serial_input"
      :body-style="{ paddingBottom: '80px' }"
      @close="() => (show_serial_input = false)"
    >
      <AddProductSerialManual
        v-model="addSerial"
        @calculate="calculate"
        :product_detail="model.product_detail"
      />
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapGetters, mapState } from 'vuex'
import AddProductSerialManual from './add-product-serial-manual.vue'
import AddAutoAfterSearchSerial from './auto-after-search-serial.vue'
import SoldPrice from './sold-price.vue'
export default {
  name: 'itemDetails',
  props: ['value', 'validate'],
  components: {
    AddProductSerialManual,
    AddAutoAfterSearchSerial,
    SoldPrice
  },
  data() {
    return {
      errors: new Errors(),
      show_serial_input: false,
      show_price: false,
      selectedProduct: [],
      addSerial: {
        product_name_en: null
      },
      model: {}
    }
  },
  computed: {
    ...mapGetters('wholesale/operation', [
      'getUom',
      'getSalePrice',
      'getDiscount',
      'getCost'
    ]),
    ...mapState('wholesale/operation', ['setting']),
    isAccounting() {
      return this.setting.is_accounting
    },
    numRow() {
      return this.model.product_detail.length
    },
    countQty() {
      return _.sumBy(this.model.product_detail, 'quantity')
    },
    sumUSDPrice() {
      return _.sumBy(this.model.product_detail, 'unit_price')
    },
    totalAmountUSDPrice() {
      //this.model.sub total same as _.sumBy(this.model.product_detail, 'grand_total')
      return this.model.sub_total
      // return _.sumBy(this.model.product_detail, 'grand_total')
    },
    isNotAllowToEdit: () => product => {
      // discount free item per amount
      if (product.promo_type_id == 3) {
        return product.unit_price == 0
      }
      // discount buy item free item
      if (product.promo_type_id == 4) {
        return (
          product.promo_ref_promo_product_id != '' &&
          product.promo_ref_promo_product_id != undefined &&
          product.promo_ref_promo_product_id > 0
        )
      }

      return false
    },
    thbRate() {
      let foundFx = this.$store.state.wholesale.saleContract.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }

      return (this.model.fx_rate_thb = 32)
    },
    locale() {
      return this.$root.$i18n.locale
    },
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    removeRow(row) {
      // remove product which related promotion
      const productionProduct = this.model.product_detail.filter(
        detail => detail.promo_ref_promo_product_id == row.product_id
      )
      productionProduct.forEach(el => {
        this.model.product_detail.splice(
          this.model.product_detail.indexOf(el),
          1
        )
      })
      // end remove product related promotion
      this.model.product_detail.splice(
        this.model.product_detail.indexOf(row),
        1
      )
      this.calculate()
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      row.cost = this.getCost({
        product_id: row.product_id,
        uom_id: row.uom_id
      })
      
      this.addProductWithDiscountByRangePromotion(row)
      this.addProductWithDiscountPromotion(row)
      this.calculate()
    },
    onChangeQuantity(row) {
      this.addProductWithDiscountByRangePromotion(row)
      this.addProductWithDiscountPromotion(row)
      this.calculate()
    },
    onChangeUnitPrice(row) {
      this.addProductWithDiscountByRangePromotion(row)
      this.calculate()
    },
    calculate() {
      this.model.product_detail.forEach(detail => {
        var amount = _.round(
          detail.unit_price * detail.quantity,
          this.default_precision
        )
        if (detail.discount_type == this.default_currency_sign) {
          detail.discount_amount = detail.discount_rate
        }
        if (detail.discount_type == '%') {
          detail.discount_amount = (amount * detail.discount_rate) / 100
        }
        detail.total_after_discount = _.round(
          amount - detail.discount_amount,
          this.default_precision
        )
        detail.vat_rate = detail.vat_rate ? detail.vat_rate : 0
        detail.vat_amount = _.round(
          (detail.total_after_discount * detail.vat_rate) / 100,
          this.default_precision
        )
        detail.grand_total = _.round(
          detail.total_after_discount + detail.vat_amount,
          this.default_precision
        )
      })

      this.model.sub_total = _.round(
        _.sumBy(this.model.product_detail, 'grand_total'),
        this.default_precision
      )
      this.model.discount = this.model.discount ? this.model.discount : 0
      this.model.total_after_discount = _.round(
        this.model.sub_total - this.model.discount,
        this.default_precision
      )
      this.model.vat_rate = this.model.vat_rate ? this.model.vat_rate : 0
      this.model.vat_amount = _.round(
        this.model.total_after_discount * (this.model.vat_rate / 100),
        this.default_precision
      )
      this.model.grand_total = _.round(
        this.model.total_after_discount +
          this.model.vat_amount -
          this.model.amount_deposit,
        this.default_precision
      )

      this.model.amount_paid = this.model.grand_total
      this.model.amount_due = 0
    },
    addSerialProduct(product) {
      this.addSerial = product
      this.show_serial_input = true
    },
    viewPrice(product) {
      this.show_price = true
      this.selectedProduct = product
    },
    priceChange() {
      this.calculate()
    },
    async addProductWithDiscountByRangePromotion(product) {
      const matchedPromotion = this.$store.getters['wholesale/operation/getRangeDiscountForProduct'](product)

      if (matchedPromotion) {
        const quantity = parseFloat(product.quantity)
        const unitPrice = parseFloat(product.unit_price)
        const rate = matchedPromotion.discount_rate
        const type = matchedPromotion.discount_type

        let discountAmountPerUnit = 0
        if (type === "%") {
          discountAmountPerUnit = (unitPrice * rate) / 100
        } else {
          discountAmountPerUnit = rate
        }

        const totalAfterDiscount = unitPrice - discountAmountPerUnit

        product.discount_type = type
        product.discount_rate = rate
        product.discount_amount = discountAmountPerUnit
        product.total_after_discount = totalAfterDiscount
        product.grand_total = totalAfterDiscount * quantity
        product.promo_type_id = matchedPromotion.promo_type_id
        // product.promo_ref_promo_product_id = matchedPromotion.promotion_id
      } else {
        product.discount_type = '%'
        product.discount_rate = 0
        product.discount_amount = 0
        product.total_after_discount = product.unit_price
        product.grand_total = product.unit_price * product.quantity
        product.promo_type_id = null
      }
    },
    async addProductWithDiscountPromotion(product) {
      const discount = this.$store.getters['wholesale/operation/getDiscountPromotionForProduct'](product)

      if (discount) {
        product.promo_type_id = discount.promo_type_id
        product.discount_rate = discount.discount_rate

        const existingProducts = this.checkProductExistingInList(product)

        if (!existingProducts.length) {
          this.model.product_detail.push(product)
        } else {
          existingProducts.forEach(el => {
            el.discount_rate = discount.discount_rate
            el.promo_type_id = discount.promo_type_id
          })
        }

        return true
      }

      return false
    },
    checkProductExistingInList(product) {
      const products = this.model.product_detail.filter(
        p => p.product_id == product.product_id && p.uom_id == product.uom_id
      )

      return products
    },
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 510px;
  max-height: 520px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  /* border-spacing: 0;  */
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}
</style>
